import * as React from 'react';
import {
    BodyLargeEmphasized,
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Sheet,
    YStack,
} from 'smoothie';

import {
    SMS_OPT_IN_BUTTON_TEXT,
    SMS_OPT_IN_DISCLOSURE_HEADLINE,
    SMS_OPT_IN_DISCLOSURE_TEXT_NOTIFICATIONS,
} from '../smsConsentDisclosure';

interface SmsConsentSheetProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const SmsConsentSheet = ({
    isOpen,
    onClose,
    onConfirm,
}: SmsConsentSheetProps) => {
    return (
        <Sheet
            isInsideModal
            isOpen={isOpen}
            onClose={onClose}
            showCloseButton={true}
        >
            <YStack gap={14}>
                <BodyLargeEmphasized>
                    {SMS_OPT_IN_DISCLOSURE_HEADLINE}
                </BodyLargeEmphasized>
                <BodyMediumRegular color="$gray1000" maxWidth={400}>
                    {SMS_OPT_IN_DISCLOSURE_TEXT_NOTIFICATIONS}
                </BodyMediumRegular>
                <Button
                    marginTop={8}
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text={SMS_OPT_IN_BUTTON_TEXT}
                    onPress={onConfirm}
                />
            </YStack>
        </Sheet>
    );
};
